import { useAppSettings } from '@fdc/components/global-state';
import React from 'react';

import { OverlayUI } from './overlay-ui';

export const Overlay: React.FC = () => {
  const { displayOverlay } = useAppSettings();
  if (!displayOverlay) {
    return null;
  }
  return <OverlayUI data-testid="app-overlay" id="app-overlay" />;
};
